export const tiposCampos = {
	LINK: "link",
	ACTIVE_LED: "activeLed",
	DROP_DOWN_ACTIONS: "dropDownActions",
	LOCAL_DATE: "localDate",
	LOCAL_DATE_TIME: "localDateTime",
	PERCENT: "percent",
	STATUS: "status",
	ACCIONES: "acciones",
	ACTIVO: "activo",
	AVATAR: "avatar",
};

export const tipoSistema = {
	ConsolaSoporte: 5,
	ConsolaSoporteSSO: 6
};